import React, { useEffect, useState } from 'react';
import {
  Box,
  IconButton,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Badge,
} from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';

import { useLocation, useNavigate } from 'react-router-dom';

import { PAGE_TITLES } from '../../constants/pageTitles';
import { HeaderProps } from '../../types/interface';

import { getUnreadCount } from '../../services/api';

// 🔥 Redux (optional snackbar)
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../store/snackbarSlice';

import './Header.css';

const Header: React.FC<HeaderProps> = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [unreadCount, setUnreadCount] = useState(0);

  const pageTitle =
    PAGE_TITLES[location.pathname] || 'Dashboard';

  // ================= FETCH UNREAD =================
  const fetchUnreadCount = async () => {
    try {
      const res = await getUnreadCount();

      const count =
        res.data?.count ||
        res.data?.data?.count ||
        0;

      setUnreadCount(count);

    } catch (err: any) {
      console.error("Unread Count Error:", err);

      dispatch(
        showSnackbar({
          message: "Failed to load notifications",
          type: "error",
        })
      );
    }
  };

  useEffect(() => {
    fetchUnreadCount();

    // 🔥 optional: auto refresh every 30 sec
    const interval = setInterval(fetchUnreadCount, 30000);

    return () => clearInterval(interval);
  }, []);

  // ================= HANDLERS =================
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    console.log('Logout clicked');
  };

  const handleNotificationClick = () => {
    navigate("/notifications"); // 🔥 redirect
  };

  return (
    <Box className="header">
      {/* LEFT */}
      <Box className="header-left">
        <IconButton
          className="header-icon-btn"
          onClick={() => setCollapsed(!collapsed)}
        >
          <MenuIcon />
        </IconButton>

        <Typography className="header-title">
          {pageTitle}
        </Typography>
      </Box>

      {/* RIGHT */}
      <Box className="header-right">

        {/* 🔔 NOTIFICATION */}
        <IconButton
          className="header-icon-btn"
          onClick={handleNotificationClick}
        >
          <Badge
            badgeContent={unreadCount}
            color="error"
            invisible={unreadCount === 0} // 🔥 hide when 0
          >
            <NotificationsIcon />
          </Badge>
        </IconButton>

        {/* 👤 PROFILE */}
        {/* <Avatar
          className="header-avatar"
          onClick={handleMenuOpen}
        >
          A
        </Avatar> */}
      </Box>
    </Box>
  );
};

export default Header;